import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { InsertTemplateDocxMutation, InsertTemplateDocxMutationVariables } from '@/graphql/generated/graphql';
import { InsertTemplateDocxDocument } from '@/graphql/generated/graphql';
export type TemplateDocxInsertInput = {
  OrganizationIds?: string[]
  TemplateId?: string
  OriginalUrl?: string
  OriginalKey?: string
  OriginalName?: string
  SizeBytes?: number
  TokenizedUrl?: string
  TokenizedKey?: string
  TokenVersion?: number
  Status?: string
}

export type InsertTemplateDocxResponse = {
  data: {
    insertTemplateDocx: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useInsertTemplateDocx = () => {
  const mutation = useMutation({
    mutationKey: ['insert-template-docx'],
    mutationFn: (variables: TemplateDocxInsertInput) => {
      return graphqlClient.request<InsertTemplateDocxMutation>(InsertTemplateDocxDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    insertTemplateDocx: mutation.mutate,
    insertTemplateDocxAsync: mutation.mutateAsync,
  }
}

export const INSERT_TEMPLATE_DOCX_MUTATION = InsertTemplateDocxDocument;
